import _ from 'lodash';
import {
  DesignModule,
  PromptObjectInput,
  PromptObjectInputSpeakAs,
  ValueOrVariableType,
  VariableReferenceScope
} from '../../../types';
import { filterNull } from '../array';
import { getVariablesFromText, GetVariablesFromTextProps } from './get-variables-from-text';

export type GetInputsFromTextProps = (
  GetVariablesFromTextProps
  & {
    /** Module the @see node is from. */
    nodeModule: DesignModule;
  }
);

export function getInputsFromText(props: GetInputsFromTextProps): PromptObjectInput[] {
  const variables = _.uniqBy(
    getVariablesFromText(props),
    ({ fullName }) => {
      return fullName;
    }
  );
  const {
    node,
    nodeModule,
    serialized
  } = props;
  const nodeInputs = (node?.props.config.inputs ?? []) as PromptObjectInput[];

  return filterNull(variables.map(({
    fullName,
    scope,
    variableName
  }): PromptObjectInput | null => {
    const nodeInput = nodeInputs.find((input) => {
      return input.varName === fullName;
    });

    if (nodeInput) {
      return nodeInput;
    }

    const variables = (scope === VariableReferenceScope.application) ? (
      serialized.components.variables
    ) : (
      nodeModule.localVariables
    );
    const variable = variables?.find((variable) => {
      return variable.props.config.varName === variableName;
    })?.props.config;

    return (!variable) ? null : {
      argumentName: fullName,
      defaultValue: variable.defaultValue ?? '',
      sensitiveData: variable.sensitiveData,
      speakAs: PromptObjectInputSpeakAs.word,
      type: ValueOrVariableType.variable,
      value: null,
      varName: fullName
    };
  }));
}
